import { render, staticRenderFns } from "./EditContactUsItem.vue?vue&type=template&id=a0307652&scoped=true&"
import script from "./EditContactUsItem.vue?vue&type=script&lang=js&"
export * from "./EditContactUsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0307652",
  null
  
)

export default component.exports